export const setWithExpiry = (
  key: string,
  value: string,
  ttl: number,
  updateTTL = false,
) => {
  let existingItem;
  if (!updateTTL) {
    const existingRaw = localStorage.getItem(key);
    if (existingRaw) {
      existingItem = JSON.parse(existingRaw);
    }
  }

  const now = new Date();
  const item = {
    value,
    expiry:
      !existingItem || updateTTL ? now.getTime() + ttl : existingItem.expiry,
  };
  localStorage.setItem(key, JSON.stringify(item));
};

export const getWithExpiry = (key: string) => {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  const item = JSON.parse(raw);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};
